import React from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import { DOCUMENT_FORM } from '../constants'

const DocumentBreadcrumbs = ({ currentPath, mode }) => {
  return (
    <div>
      <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
      <Breadcrumb
        data={{
          title: 'Settings',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Signup Identification Documents',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.settings.documentation
          }`,
        }}
      />
      {mode === DOCUMENT_FORM.CREATE && (
        <Breadcrumb data={{ title: 'Create', pathname: currentPath }} />
      )}
      {mode === DOCUMENT_FORM.EDIT && (
        <Breadcrumb data={{ title: 'Edit', pathname: currentPath }} />
      )}
    </div>
  )
}

export default DocumentBreadcrumbs



// WEBPACK FOOTER //
// ./src/Containers/Settings/Documentation/DocumentBreadcrumbs/index.js